import React, { useRef, useEffect, createRef, useImperativeHandle, forwardRef, useState } from 'react'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
import styled from 'styled-components'
import { FlexByRow, XDivider, YDivider, useTheme, FlexByRowCentered } from 'irmlib/styles'
import { OutlinedButton, Label, Box, ThemeButton, ContainedButton } from 'irmlib/components/Controls'
import { SaveButton, CancelButton, TextFieldBorderless, TextField } from 'irmlib/components/FormControls'
import { useFormPageHandler, useMergeState, useConstructor } from 'irmlib/hooks'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import { LocalToast, setBusy, clearBusy, openGeneralDialog, closeGeneralDialog } from 'irmlib/containers'
import { useNavigatorOnLine } from '../../../utils/useNavigatorOnline'
import PropTypes from 'prop-types'
import DatGridTable from '../../Controls/DataGridTable/index'
import { getJobById } from '../../../services/firestore/gdeTransactions' // getTemplateFields
import GoBackSubtitle from '../../Controls/GoBackSubtitle'
import cloneDeep from 'clone-deep'
import { getValidations, successToast, errorToast } from '../../../common/functions'
import { specialCharacterRegex } from '../../../irmlib/src/components/FormControls/regx'
import { useHistory } from 'react-router-dom'
import { userTypes } from '../../../common/constants'
// import * as routePaths from '../../../navigation/routePaths'
import * as appConstants from '../../../services/common/appConstants'
import { useTranslation } from 'react-i18next'
import { translate } from '../../../irmlib/src/multilanguage'
// import { element } from 'prop-types'

const VerticalDivider = () => <YDivider height="30px" />

const BottomPaddedButton = (props) => (
  <>
    <ThemeButton {...props} />
    <VerticalDivider />
  </>
)

const SKPBOX = 0
// const DIV = 1
// const DEPT = 2

const SKP_BOX_ID = 'skpBoxId'
const CUSTOMER_ID = 'customerId'
const MAINTENANCE_CODE = 'maintenanceCode'


const BoxStyle = styled('div')`
    width: 25%; 
    padding-top: 10px;
    padding-left: 10px;
    padding-bottom: 10px;
    background-color: ${props => props.theme.palette.subPageHeaderBackground};
`

const LableStyle = styled('div')`
  border-right: 1px solid;
`

const BoxUp = styled('div')`
  background-color: ${props => props.theme.palette.subPageHeaderBackground};
  border-radius: ${props => props.theme.shape.borderRadius};
`

const WidthForSkpBox = styled('div')`
  width: 33%;
`

const MarginLeft = styled('div')`
  margin-left: 20px;
`

const PrimaryLabel = styled(Label)`
  color: ${props => props.theme.palette.primary.main};
`

const Buttons = props =>
  <>
    {props.isViewAllFiles && <CancelButton onClick={props.handleBackToBoxList} arrRefs={props.arrRefs} />}
    {!props.isViewAllFiles && <CancelButton onClick={props.handleCancel} arrRefs={props.arrRefs} />}
    {props.currentTemplateType !== 'New Box' && props.currentTemplateType !== 'Maintenance Box' &&
      <>{!props.isViewAllFiles && <XDivider width='10px' />}
        {!props.isViewAllFiles && <SaveButton disabled={props.existBoxErrors} arrRefs={props.buttonRef} postService={props.onClickSave} />}
        {!props.isViewAllFiles && <XDivider width='10px' />}
        {!props.isViewAllFiles && (props.currentUserType?.current === props.userTypes.VERIFICATION_USER || props.currentUserType?.current === props.userTypes.DATAENTRY_AND_VERIFY_USER || props.currentUserType?.current === props.userTypes.DATAENTRY_USER) && <BottomPaddedButton id={'dataEntry_button_select_fieldstoupdate'} variant='contained' color='primary' onClick={() => { props.handleUpdateSequenceModal() }} disabled={!props.enableUpdateSequenceBtn}>
          buttons.updateFileSequenceBtn
        </BottomPaddedButton>}</>}
    <XDivider width='10px' />
    {(props.currentTemplateType === 'New Box' || props.currentTemplateType === 'Maintenance Box') && <SaveButton disabled={props.existBoxErrors} arrRefs={props.buttonRef} postService={props.onClickSaveBoxes} />}
  </>

Buttons.propTypes = {
  handleCancel: PropTypes.func,
  handleBackToBoxList: PropTypes.func,
  arrRefs: PropTypes.node,
  onClickSave: PropTypes.func,
  onClickSaveBoxes: PropTypes.func,
  handleUpdateSequenceModal: PropTypes.func,
  existBoxErrors: PropTypes.bool,
  enableUpdateSequenceBtn: PropTypes.bool,
  buttonRef: PropTypes.any,
  isViewAllFiles: PropTypes.string,
  currentUserType: PropTypes.string,
  currentTemplateType: PropTypes.string,
  userTypes: PropTypes.any,
}

const getService = async () => {
  const getObject = {
  }
  return Promise.resolve(getObject)
}

const initialState = {
  fileList: [],
  columnsList: [],
  templateName: '',
  showDataEntryPage: false,
  jobDetails: {},
  boxCount: 0,
  indexPointerOfFile: 0,
  initialFileList: [],
  existBoxErrors: false,
  bulkUpdateBtn: false,
  enableInputField: true,
  tempFileList: [],
  selectedFiles: [],
  updateFileSequence: [],
  enableUpdateSequenceBtn: false,
  refresh: false,
  regexFormat: ''
}

const ViewAllFiles = forwardRef((props, ref) => {
  const { t } = useTranslation()
  const [state, setState, getState] = useMergeState(initialState)
  const boxesKeyed = props
  const boxes = boxesKeyed.boxCount
  const refLocalBusyCursor = useRef(null)
  const refLocalToast = useRef(null)
  const theme = useTheme()
  const boxId = props.boxId
  const fileCount = props.fileCount
  const isViewAllFiles = props.isViewAllFiles
  const currentUserType = props.currentUserType
  const currentTemplateType = props.currentTemplateType.current
  const refFileList = useRef()
  const buttonRef = useRef()
  const refFileCount = useRef()
  const [validationErrors, setValidationErrors] = useState({})
  const [existBoxErrors] = useState(false)
  const [indexPointerOfFile] = useState(fileCount)
  const [showStatus, isStatusShown] = useState(false)
  const [duplicateErrors, setDuplicateErrors] = useState({})
  const history = useHistory()
  const online = useNavigatorOnLine()
  const [dropFirstLetterSkpBox, setDropFirstLetterSkpBox] = useState(false)
  const defaultFileColumn = {
    title: translate('tableColumns.srNo'),
    field: 'Sr_No',
    headerAlign: 'left',
    sortable: false,
    flex: 1,
    getRowHeight: 'auto',
    // minWidth: 200,
  }

  const changeSeqFileColumn = {
    title: t('tableColumns.changeFileSeq'),
    field: 'fileSequence',
    headerAlign: 'left',
    flex: 1,
    getRowHeight: 'auto',
    minWidth: 200,
    sortable: true,
    renderCell: (rowdata) => {
      const { updateFileSequence } = getState()
      let sequenceNo = ''
      if (rowdata.Sr_No !== updateFileSequence[rowdata.fileId]?.sequenceNo) {
        sequenceNo = updateFileSequence[rowdata.fileId]?.sequenceNo
      }

      const fieldName = 'fileSequence'
      const arrRef = createRef()
      const formTemplate = {
        fieldKey: '',
        defaultValue: sequenceNo,
      }
      return (<TextFieldBorderless ref={arrRef} fieldTemplate={formTemplate} onChange={(e) => handleChangeSequence(rowdata, fieldName, e, arrRef)} readOnly={!!isViewAllFiles || false} />)
    }
  }

  useConstructor(() => {
    refFileList.current = cloneDeep(props.fileList)
    refFileCount.current = cloneDeep(props.currentFileCount)
  })

  const formTemplate = [
    {
      label: 'dataEntry.skpBoxID',
      fieldKey: 'obj.obj1.skpId',
    },
    {
      label: 'dataEntry.divisionID',
      fieldKey: 'obj.obj1.divisionId',
    },
    {
      label: 'dataEntry.departmentID',
      fieldKey: 'obj.obj1.departmentId',
    }
  ]

  const [arrRefs] = useFormPageHandler({
    formTemplate,
    service: getService,
    busyOverride: refLocalBusyCursor,
  }
  )

  const ButtonsForBrowserBackPress = (props) => (
    <>
      <OutlinedButton id={'viewAllFiles_cancel_goBack'} onClick ={stayOnCurrentPage}>buttons.no</OutlinedButton>
      <XDivider width='10px' />
      <ContainedButton id={'viewAllFiles_allow_goBack'} onClick ={goBackToDataEntry}>buttons.yes</ContainedButton>
    </>
  )

  const stayOnCurrentPage = () => {
    closeGeneralDialog()
  }
  const goBackToDataEntry = () => {
    closeGeneralDialog()
    window.removeEventListener('popstate', backButton)
    onClicksave()
  }


  const backButton = () => {
    window.history.pushState(null, '', window.location.href)

    openGeneralDialog({
      title: t('dataEntry.warning'),
      message: <Label>dataEntry.warningMessage</Label>,
      translateMessage: false,
      noTranslateTitle: true,
      buttons: (<ButtonsForBrowserBackPress arrRefs={arrRefs} />
      ),
      closeX: true
    })
  }

  useEffect(() => {
    window.addEventListener('popstate', backButton)
    window.history.pushState(null, '', window.location.href)
    return () => {
      window.removeEventListener('popstate', backButton)
    }     
  }, [])

  useEffect(() => {
    setBusy()
    handleGetJobData()
    clearBusy()
  }, [])

  useEffect(() => {
    if (online) {
      showStatus && successToast({ message: t('toast.onlineMsg'), autoHideDuration: 5000, closeIcon: true })
    } else {
      isStatusShown(true)
      errorToast({ 
        message: <ul dangerouslySetInnerHTML={ { __html: t('toast.offlineStatus') } } style={{ padding: '0', margin: '0' }}></ul>, 
        title: t('toast.userOffline'),
        autoHideDuration: 20000,
        isBlocking: true, 
        closeIcon: true 
      })
    }
  }, [online])

  const handleGetJobData = async () => {
    const rawJobByIdData = await getJobById(props.jobId)
    const jobData = rawJobByIdData.data()
    const [, , , , skpEncoding] = await gdeTransactions.getGdeConfig()
    const regexFormat = skpEncoding[jobData?.countryCode]?.regex
    let _templateName = ''
    const columnList = [defaultFileColumn]
    if (currentTemplateType === 'Maintenance File' || currentTemplateType === 'New File') {
      !isViewAllFiles && columnList.push(changeSeqFileColumn)
    }

    if (jobData.templateName !== '' && jobData.templateName !== undefined) {
      _templateName = jobData.templateName
    } else {
      _templateName = jobData.standardTemplateName
    }
    // const rawTemplateData = await getTemplateFields(_templateName)
    const rawTemplateData = jobData.templateData
    let templateFields = rawTemplateData.templateFields
    templateFields = Object.keys(templateFields).map((key) => {
      const data = templateFields[key]
      data.name = key
      return data
    })
    templateFields.sort((a, b) => (a.customOrder > b.customOrder) ? 1 : ((b.customOrder > a.customOrder) ? -1 : 0))

    templateFields.forEach((element) => {
      if ((element.isSelected && element.name !== SKP_BOX_ID && element.name !== CUSTOMER_ID && element.name !== MAINTENANCE_CODE) || (element.isSelected && element.name !== CUSTOMER_ID && element.name !== MAINTENANCE_CODE && currentTemplateType !== 'Maintenance File' && currentTemplateType !== 'New File')) {
        columnList.push({
          title: element.customName ? element.customName : element.name,
          field: element.name,
          editable: !props.isViewAllFiles && true,
          headerAlign: 'left',
          minWidth: 200,
          getRowHeight: 'auto',
          flex: 1,
          sortable: true,
          cellStyle: {
            overflow: 'hidden',
          },
          renderCell: (rowdata) => {
            const fieldName = element.name
            const arrRef = createRef()
            const formTemplate = {
              fieldKey: '',
              defaultValue: rowdata.row[element.name],
            }
            return (<TextFieldBorderless ref={arrRef} fieldTemplate={formTemplate} disabled={element.name === 'skpBoxId'} multiline onChange={(e) => handleChange(rowdata, fieldName, element, e, arrRef)} readOnly={!!isViewAllFiles || false || element.name === SKP_BOX_ID} />)
          }
        })
      }
    })

    // if (currentTemplateType !== 'Maintenance File' && currentTemplateType !== 'New File') {
    //   columnList.splice(0, 1)
    // }

    const fileList = []
    refFileList.current.forEach((doc, index) => {
      const file = doc
      file.Sr_No = index + 1
      file.id = index + 1
      fileList.push(file)
    })

    setState({
      initialFileList: refFileList.current,
      fileList: fileList,
      columnsList: columnList,
      tempFileList: fileList,
      fileCount: refFileCount.current,
      templateName: _templateName,
      jobDetails: jobData,
      boxCount: boxes,
      regexFormat: regexFormat
      // jobData.boxesCompleted ? jobData.boxesCompleted : 0
    })

    return fileList
  }

  const onCancel = () => {
    closeGeneralDialog()
  }

  const handleUpdateSequenceModal = (jobId, boxId) => {
    openGeneralDialog({
      title: <FlexByRowCentered><Label>dataEntry.updateFileSequence</Label></FlexByRowCentered>,
      message: t('dataEntry.changeFileSeq'),
      buttons:
  <>
    <CancelButton onClick={onCancel} />
    <XDivider width='10px' />
    <ContainedButton onClick={() => handleUpdateSequence(jobId, boxId)} >buttons.yes</ContainedButton>
  </>,
      closeX: true
    })
  }

  const handleUpdateSequence = async (jobId, boxId) => {
    setBusy()
    const filesForBox = await gdeTransactions.getFilesForBox(jobId, boxId)
    const filesListFromGde = filesForBox.docs.sort(function (a, b) {
      return a.id.localeCompare(b.id, undefined, {
        numeric: true,
        sensitivity: 'base'
      })
    })

    const { updateFileSequence } = getState()
    const updatedSequenceArray = []
    let index = 0
    for (const [key, value] of Object.entries(updateFileSequence)) {
      const updatedSequenceData = []
      const { sequenceNo, sequenceType } = value
      const { Sr_No: oldSequenceNo, fileId } = value.row
      updatedSequenceData.key = key
      updatedSequenceData.oldSequenceNo = oldSequenceNo
      updatedSequenceData.fileId = fileId
      updatedSequenceData.sequenceNo = sequenceNo
      updatedSequenceData.sequenceType = sequenceType
      updatedSequenceArray[index++] = updatedSequenceData
    }

    // below for loop is written to separate exisitng sequence files & new sequence files
    const newSequencesFiles = []
    const newSequencesFileIds = []
    let newSequenceIndex = 0

    for (let counter = 1; counter <= filesListFromGde.length; counter++) {
      // this looping is for new files sequence
      updatedSequenceArray.forEach((row, index) => {
        if (row.sequenceType === 'new_sequence' && counter === row.sequenceNo) {
          newSequencesFiles[newSequenceIndex++] = row
          newSequencesFileIds[row.fileId] = row
        }
      })
    }

    let oldSequenceIndex = 0
    const oldSequencesFiles = []
    filesListFromGde.forEach(async (doc, index) => {
      const docData = doc.data()
      const oldDataFileId = docData.fileInfo.fileId
      if (!newSequencesFileIds[oldDataFileId]) {
        const updatedSequenceData = []
        updatedSequenceData.oldSequenceNo = parseInt(oldDataFileId)
        updatedSequenceData.fileId = oldDataFileId
        updatedSequenceData.sequenceNo = parseInt(oldDataFileId)
        updatedSequenceData.sequenceType = 'existing_sequence'
        oldSequencesFiles[oldSequenceIndex++] = updatedSequenceData
      }
    })

    // this for loop is written to push new sequence files in the list of old sequence files as per sequence no. provided
    newSequencesFiles.forEach((row, index) => {
      oldSequencesFiles.splice(--row.sequenceNo, 0, row)
    })

    oldSequencesFiles.forEach(async (doc) => {
      await gdeTransactions.deleteFile(jobId, boxId, doc.fileId)
    })

    const newFileList = []
    const newFileList2 = []
    const myPromise = new Promise(function (resolve, reject) {
      setTimeout(
        filesListFromGde.forEach(async (doc, index) => {
          const docData = doc.data()
          oldSequencesFiles.forEach(async (document, documentIndex) => {
            if (document.fileId === docData.fileInfo.fileId && !newFileList[index]) {
              const newLocationOfFile = documentIndex + 1
              const newFileName = newLocationOfFile.toString().padStart(5, '0')
              docData.fileInfo.fileId = newFileName
              docData.fileNumber = newFileName
              delete docData.fileInfo.sequenceNo
              delete docData.fileInfo.sequenceType
              newFileList[index] = docData.fileInfo
              newFileList2[documentIndex] = docData.fileInfo
              await gdeTransactions.createFile(jobId, boxId, newFileName, docData)
            }
          })
        })
        , 5000)
      resolve(newFileList2)
    })
    const existingFileData = []
    // eslint-disable-next-line
    for (const [index, element] of tableRef.current.getRowModels().entries()) {
      existingFileData.push(element)
    }
    myPromise.then(function (newFileList2) {
      setTimeout(successToast({ message: t('toast.filesSeqUpdSuccess') }), 50000)
      setTimeout(props.onCloseTable(currentUserType, existingFileData, jobId, boxId, indexPointerOfFile, true, newFileList2, props.currentLockableFields, props.currentLockableFieldsData), 50000)
      setTimeout(closeGeneralDialog(), 50000)
    })
  }

  const handleChangeSequence = async (rowdata, field, value, arrRef) => {
    rowdata.sequenceType = 'existing_sequence'
    rowdata.sequenceNo = parseInt(rowdata.id)
    if (isNaN(value) || value > refFileList.current.length || value < 0) {
      arrRef.current.setValue('')
      rowdata.sequenceType = 'existing_sequence'
      rowdata.sequenceNo = parseInt(rowdata.id)
    } else if (value && rowdata.Sr_No !== value) {
      rowdata.sequenceType = 'new_sequence'
      rowdata.sequenceNo = parseInt(value)
    }
    setState({
      enableUpdateSequenceBtn: false,
      updateFileSequence: { ...getState().updateFileSequence, [rowdata.id]: rowdata },
    })

    for (const [key, value] of Object.entries(getState().updateFileSequence)) {
      const { sequenceType } = value
      if (sequenceType === 'new_sequence' && key) {
        setState({
          enableUpdateSequenceBtn: true,
        })
      }
    }
  }

  const handleChange = (rowdata, field, templateFields, value, arrRef,) => {
    const updatedTempFileList = []
    const duplicateErrs = duplicateErrors
    let duplicateFound = false
    if (templateFields.doNotDuplicate) {
      getState()?.tempFileList.forEach((doc, index) => {
        if (templateFields.doNotDuplicate && value === doc[field] && index + 1 !== rowdata.id && doc[field] !== '') {
          duplicateFound = true
          arrRef?.current?.setErrorMsg('dataEntry.duplicateValue')
          // eslint-disable-next-line 
          duplicateErrs[rowdata.id + '-' + templateFields.name] = t('dataEntry.duplicateValue')
          setDuplicateErrors(duplicateErrs)
        } else if (templateFields.doNotDuplicate && value !== doc[field] && index + 1 !== rowdata.id && !duplicateFound) {
          // eslint-disable-next-line 
          delete duplicateErrs[rowdata.id + '-' + templateFields.name]
          setDuplicateErrors(duplicateErrs)
        }
      })
    }
    getState()?.tempFileList.forEach((doc, index) => {
      if (index + 1 === rowdata.id) {
        doc[field] = value
      }
      updatedTempFileList.push(doc)
    })
    setState({ tempFileList: updatedTempFileList })
    const [errorMsg, noTranslate = false] = getValidations(templateFields, arrRef, props.jobId, getState()?.tempFileList, getState()?.jobDetails?.skpinstance, getState()?.regexFormat)
    const errors = validationErrors
    if (errorMsg !== undefined) {
      if (noTranslate) {
        arrRef?.current?.setErrorMsg(errorMsg, noTranslate)
      } else {
        arrRef?.current?.setErrorMsg(errorMsg)
      }
      errors[rowdata.id + templateFields.name] = errorMsg
    } else {
      rowdata[field] = value
      if (value && Boolean(templateFields?.specifyLength)) {
        const valueWithLeadingZeros = value.padStart(templateFields?.specifyLength, '0')
        rowdata[field] = valueWithLeadingZeros
      }
      delete errors[rowdata.id + templateFields.name]
    }
    setValidationErrors(errors)
    if (currentTemplateType === 'Maintenance File' || currentTemplateType === 'New File') {
      arrRefs[SKPBOX].current.setValue(arrRefs[SKPBOX].current.getValue())
    }
  }

  const tableRef = useRef(null)

  const convertToUpperCase = async (e) => {
    e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, '')

    let skpBoxValue = e.target.value
    const firstElement = Array.from(skpBoxValue)[0]
    const barcodeLogic = getState()?.jobDetails?.barcodeLogic || appConstants?.originalBarcodeLogic

    if (skpBoxValue.length === 0) {
      setDropFirstLetterSkpBox(false)
    }
    
    if (skpBoxValue.length > 0) {
      for (const [key, value] of Object.entries(barcodeLogic)) {
        if (key.includes(firstElement?.toUpperCase())) {
          const lengthLimit = value.logic.limit
          const operator = value.logic.operator
          const trim = value.logic.trim
          // eslint-disable-next-line
          if (trim && eval(`${skpBoxValue.length} ${operator} ${lengthLimit}`)) {
            if (!dropFirstLetterSkpBox) {
              skpBoxValue = skpBoxValue.substring(1)
              setDropFirstLetterSkpBox(true)
            }
          }
        }
      }
    }

    return e.target.value = ('' + skpBoxValue).toUpperCase()
  }

  const convertToUpperCaseBackup = async (e) => {
    let skpBoxValue = e.target.value
    const firstElement = Array.from(skpBoxValue)[0]
    const arrayOfIgnoredChars = appConstants.ignoreBarcodeScanCharacters

    if (skpBoxValue.length === 0) {
      setDropFirstLetterSkpBox(false)
    }

    if (skpBoxValue.length === 12 && arrayOfIgnoredChars.indexOf(firstElement.toUpperCase()) !== -1) {
      skpBoxValue = skpBoxValue.substring(1)
    } else if (arrayOfIgnoredChars.indexOf(firstElement?.toUpperCase()) !== -1 && firstElement.toUpperCase() !== 'R' && skpBoxValue.length > 1) {
      if (!dropFirstLetterSkpBox) {
        skpBoxValue = skpBoxValue.substring(1)
        setDropFirstLetterSkpBox(true)
      }
    }
    // eslint-disable-next-line
    return e.target.value = ('' + skpBoxValue).toUpperCase()
  }

  const skpBoxValue = async (e) => {
    const regexObj = new RegExp(specialCharacterRegex)
    if (e.key && e.key.length === 1 && regexObj.test(e.key)) {
      e.preventDefault()
      return
    }

    if (e.keyCode === 13) {
      if (e.target.value !== '') {
        validateSkpBoxValue(e)
      } else if (e.target.value === '') {
        arrRefs[SKPBOX].current.setErrorMsg('dataEntry.boxIdInvalid')
      }
    }
  }

  const validateSkpBoxValue = async (e) => {
    setBusy()
    if (e.target.value.length > 11) {
      arrRefs[SKPBOX].current.setErrorMsg('dataEntry.boxLengthInvalid')
    } else {
      const boxes = await gdeTransactions.getBox(props.jobId, e.target.value)
      if (boxes.exists()) {
        if (arrRefs[SKPBOX].current.getValue() !== undefined && arrRefs[SKPBOX].current.getValue() !== boxId) {
          arrRefs[SKPBOX].current.setErrorMsg('dataEntry.boxAlreadyExists')
          arrRefs[SKPBOX].current.focus()
        }
      }
    }
    clearBusy()
  }

  // const BoxDetailsPanel = () => {
  //   return (
  //     <WidthForSkpBox>
  //       <MarginLeft>
  //         <TextField
  //           ref={arrRefs[SKPBOX]}
  //           fieldTemplate={formTemplate[SKPBOX]}
  //           value={arrRefs[SKPBOX]?.current?.getValue() === undefined ? boxId : arrRefs[SKPBOX]?.current?.getValue()}
  //           // value={boxId}
  //           disabled={!!isViewAllFiles || false}
  //           onKeyDown={(e) => skpBoxValue(e)}
  //           // onBlur={(e) => onBlurSkpValueConfirm(e)}
  //           onInput={(e) => convertToUpperCase(e)}
  //           inputProps={{ maxLength: 12 }}
  //         />
  //       </MarginLeft>
  //     </WidthForSkpBox>
  //   )
  // }

  useImperativeHandle(ref, () => ({
    getValues: () => {
      return ({
      })
    },
  }))

  const onClicksave = async (e) => {
    setBusy()
    let allowToSave = true
    if (arrRefs[SKPBOX]?.current?.getValue() !== undefined) {
      if (arrRefs[SKPBOX].current.getValue() === '') {
        arrRefs[SKPBOX].current.setErrorMsg('dataEntry.boxIdInvalid')
        allowToSave = false
      } else if (arrRefs[SKPBOX].current.getValue().length > 11) {
        arrRefs[SKPBOX].current.setErrorMsg('dataEntry.boxLengthInvalid')
        arrRefs[SKPBOX].current.focus()
        allowToSave = false
      } else {
        const boxes = await gdeTransactions.getBox(props.jobId, arrRefs[SKPBOX].current.getValue())
        if (boxes.exists()) {
          if (arrRefs[SKPBOX].current.getValue() !== undefined && arrRefs[SKPBOX].current.getValue() !== boxId) {
            arrRefs[SKPBOX].current.setErrorMsg('dataEntry.boxAlreadyExists')
            arrRefs[SKPBOX].current.focus()
            allowToSave = false
          }
        }
      }
    }

    if (allowToSave === true) {
      const databoxDetails = await gdeTransactions.getBox(props.jobId, boxId)
      const boxData = databoxDetails.data()
      if (arrRefs[SKPBOX]?.current?.getValue() !== undefined) {
        await gdeTransactions.deleteBoxData(props.jobId, boxId)
        boxData.boxId = arrRefs[SKPBOX].current.getValue()
        gdeTransactions.createNewBox(props.jobId, arrRefs[SKPBOX].current.getValue(), boxData)
        const filesForBox = await gdeTransactions.getFilesForBox(props.jobId, boxId)

        const files = filesForBox.docs.sort(function (a, b) {
          return a.id.localeCompare(b.id, undefined, {
            numeric: true,
            sensitivity: 'base'
          })
        })

        files.forEach((doc) => {
          const docData = doc.data()
          docData.fileInfo.skpBoxId = boxData.boxId
          gdeTransactions.createFile(props.jobId, boxData.boxId, doc.data().fileNumber, docData)
        })
        if (Object.keys(validationErrors).length === 0 && Object.keys(duplicateErrors).length === 0) {
          const changedFileData = []
          // eslint-disable-next-line
          for (const [index, element] of tableRef.current?.getRowModels()?.entries()) {
            changedFileData.push(element)
          }
          props.onCloseTable(currentUserType, changedFileData, props.jobId, arrRefs[SKPBOX]?.current?.getValue(), fileCount, '', '', props.currentLockableFields, props.currentLockableFieldsData)
        }
      } else {
        if (Object.keys(validationErrors).length === 0 && Object.keys(duplicateErrors).length === 0) {
          const changedFileData = []
          // eslint-disable-next-line
          for (const [index, element] of tableRef?.current?.getRowModels()?.entries()) {
            changedFileData.push(element)
          }
          Object.keys(changedFileData).forEach(key => {
            Object.keys(changedFileData[key]).forEach(key1 => {
              const singleFileData = changedFileData[key]
              if (singleFileData[`${key1}_verify`] !== undefined) {
                changedFileData[key][`${key1}_verify`] = singleFileData[key1]
              }
            })
          })
          await gdeTransactions.updateFileAsBatch(props.jobId, boxId, changedFileData, getState().jobDetails.accountLevel1.toUpperCase())
          props.onCloseTable(currentUserType, changedFileData, props.jobId, boxId, fileCount, '', '', props.currentLockableFields, props.currentLockableFieldsData)
        }
      }
    }
    clearBusy()
  }

  const onClickSaveBoxes = async (e) => {
    if (Object.keys(validationErrors).length === 0 && Object.keys(duplicateErrors).length === 0) {
      const boxesListToUpdate = []
      // eslint-disable-next-line
      for (const [index, element] of tableRef.current.getRowModels().entries()) {
        boxesListToUpdate.push(element)
      }
      let boxData = {}
      boxesListToUpdate.forEach((box) => {
        const boxName = box.skpBoxId || box.boxId
        const boxStatus = box.status ? box.status : ''
        box.skpBoxId = boxName
        if (getState()?.jobDetails?.dataEntryType === 'Maintenance Box' && getState()?.jobDetails?.templateData?.templateFields !== undefined) {
          box.maintenanceCode = getState()?.jobDetails?.templateData?.templateFields?.maintenanceCode?.defaultValue
        }
        box.customerId = getState().jobDetails.accountLevel1.toUpperCase()
        delete box.status
        boxData = {
          actionTs: new Date(),
          boxInfo: box,
        }
        gdeTransactions.updateBox(getState().jobDetails.jobId, boxName, boxData)
        // adding status key back
        box.status = boxStatus
      })
      props.onCloseTable(currentUserType, boxesListToUpdate, props.jobId, boxId, fileCount, '', '', props.currentLockableFields, props.currentLockableFieldsData, currentTemplateType)
    }
  }
  return (
    <>
      <MainRouteSubRoutePage
        mainTitle={isViewAllFiles ? 'dataEntry.viewAllFiles' : 'dataEntry.dataEntry'}
        subTitle={<GoBackSubtitle title={isViewAllFiles ? 'dataEntry.viewFiles' : 'dataEntry.dataEntryViewAllFiles'} onClickBack={() => isViewAllFiles ? props.onBackToBoxList(history, props.jobId) : backButton()} />}
        buttons={<Buttons existBoxErrors={existBoxErrors} enableUpdateSequenceBtn={getState().enableUpdateSequenceBtn} arrRefs={arrRefs} buttonRef={buttonRef} onClickSave={onClicksave} onClickSaveBoxes={onClickSaveBoxes} handleCancel={() => props.onCancel(boxId, fileCount, props.currentLockableFields, props.currentLockableFieldsData, currentTemplateType)} isViewAllFiles={isViewAllFiles} handleBackToBoxList={() => props.onBackToBoxList(history, props.jobId)} handleUpdateSequenceModal={() => handleUpdateSequenceModal(props.jobId, boxId)} currentUserType={currentUserType} userTypes={userTypes} currentTemplateType={currentTemplateType} />}>
        <BoxUp theme={theme}>
          <LocalToast ref={refLocalToast} />
          <YDivider height='15px' />
          <FlexByRow>
            <XDivider width="15px" />
            <BoxStyle theme={theme}>
              <Box>
                <LableStyle><Label>dataEntry.jobId</Label></LableStyle>
                <YDivider />
                <LableStyle><Label noTranslate>{props.jobId}</Label></LableStyle>
              </Box>
            </BoxStyle>
            <BoxStyle theme={theme}>
              <Box>
                <LableStyle><Label>dataEntry.customerId</Label></LableStyle>
                <YDivider />
                <LableStyle><Label noTranslate>{state?.jobDetails?.accountLevel1?.toUpperCase()}</Label></LableStyle>
              </Box>
            </BoxStyle>
            <BoxStyle theme={theme}>
              <Box>
                <LableStyle><Label>dataEntry.templateName</Label></LableStyle>
                <YDivider />
                <LableStyle><Label noTranslate>{state.templateName}</Label></LableStyle>
              </Box>
            </BoxStyle>
            {currentTemplateType !== 'New Box' && currentTemplateType !== 'Maintenance Box'
              ? (
                <>
                  <BoxStyle theme={theme}>
                    <Box>
                      <LableStyle><Label>dataEntry.boxesCompleted</Label></LableStyle>
                      <YDivider />
                      <LableStyle theme={theme}>{state.boxCount}</LableStyle>
                    </Box>
                  </BoxStyle>
                  <BoxStyle theme={theme}>
                    <Box>
                      <Label><Label>dataEntry.filesKeyed</Label></Label>
                      <YDivider />
                      <PrimaryLabel theme={theme}>{state.fileList.length}</PrimaryLabel>
                    </Box>
                  </BoxStyle>
                  <XDivider width="15px" />
                </>
                )
              : null
            }
          </FlexByRow>
          {currentTemplateType !== 'New Box' && currentTemplateType !== 'Maintenance Box'
            ? (
              <>
                <YDivider height='15px' />
                <WidthForSkpBox>
                  <MarginLeft>
                    <TextField
                      ref={arrRefs[SKPBOX]}
                      fieldTemplate={formTemplate[SKPBOX]}
                      value={arrRefs[SKPBOX]?.current?.getValue() === undefined ? boxId : arrRefs[SKPBOX]?.current?.getValue()}
                      // value={boxId}
                      disabled={!!isViewAllFiles || false}
                      onKeyDown={(e) => skpBoxValue(e)}
                      // onBlur={(e) => onBlurSkpValueConfirm(e)}
                      onInput={(e) => convertToUpperCase(e)}
                      inputProps={{ maxLength: 12 }}
                    />
                  </MarginLeft>
                </WidthForSkpBox>
                <YDivider height='15px' />
              </>
              )
            : null
          }
        </BoxUp>
        <YDivider height='30px' />
        <DatGridTable
          statusTobeUpdated={props.statusTobeUpdated}
          onCloseTable={props.onCloseTable}
          onCancel={props.onCancel}
          currentLockableFields={props.currentLockableFields}
          currentLockableFieldsData={props.currentLockableFieldsData}
          fileList={state.fileList}
          columnsList={state.columnsList}
          apiRef={tableRef}
          arrRefs={arrRefs}
          buttonRef={buttonRef}
          boxId={boxId}
          acc2={state.jobDetails.accountLevel2}
          acc3={state.jobDetails.accountLevel3}
          jobId={props.jobId}
          isFromQC={false}
          isViewAllFiles={isViewAllFiles}
          currentUserType={currentUserType}
          currentTemplateType={currentTemplateType}
          indexPointerOfFile={indexPointerOfFile}
          dataEntryType={currentTemplateType}
        />
      </MainRouteSubRoutePage>
    </>
  )
})

ViewAllFiles.propTypes = {
  fileList: PropTypes.object,
  jobId: PropTypes.string,
  boxId: PropTypes.string,
  isViewAllFiles: PropTypes.string,
  onCloseTable: PropTypes.func,
  onCancel: PropTypes.func,
  onBackToBoxList: PropTypes.func,
  currentFileCount: PropTypes.any,
  statusTobeUpdated: PropTypes.any,
  fileCount: PropTypes.any,
  currentLockableFields: PropTypes.any,
  currentLockableFieldsData: PropTypes.any,
  currentUserType: PropTypes.any,
  currentTemplateType: PropTypes.any,
}


export default ViewAllFiles